if (!customElements.get('product-recommendations')) {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
    }

    extractProductRecommendations(html) {
      const match = html.match(/<product-recommendations[^>]*>([\s\S]*?)<\/product-recommendations>/);
      return match ? match[1].trim() : '';
    }

    connectedCallback() {
      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const recommendationsHTML = this.extractProductRecommendations(text);

          if (recommendationsHTML.length) {
            this.innerHTML = lazyTemplateController.cleanHTMLWithTemplate(recommendationsHTML);
            scriptController.saveExternalResourcesFromContainer(this);
          }
          if (!this.querySelector('slider-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }
          if (this.querySelector('.slider__slide')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
}